import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@babackapp/ui/components/card";
import type { PropsWithChildren } from "react";
import Switch from "@/components-legacy/switch";
import {
	IntegrationConfigurationTag,
	type StripeConfigurationStatus,
} from "./integration-configuration-tag";
import IntegrationDialog from "./integration-dialog";

type IntegrationPreviewProps = {
	title: string;
	description?: string;
	bgColor?: string;
	textColor?: string;
	onConfigure?: () => void;
	logo?: string;
	onActivationUpdate?: (activated: boolean) => void;
	activated?: boolean;
	badge?: StripeConfigurationStatus;
	seeMoreUrl: string;
	open?: boolean;
};

export default function IntegrationPreview({
	title,
	description,
	logo,
	bgColor,
	badge,
	textColor,
	onConfigure,
	children,
	activated,
	seeMoreUrl,
	onActivationUpdate,
	open,
}: PropsWithChildren<IntegrationPreviewProps>) {
	return (
		<Card className="w-full h-[280px]">
			<CardHeader>
				<div className="flex flex-row justify-between items-center mb-2">
					<div className="items-center gap-2 flex flex-row">
						<div
							className="w-8 h-8 rounded-full bg-contain bg-no-repeat bg-center border-1 border flex justify-center items-center"
							style={{ backgroundColor: bgColor ?? "black" }}
						>
							<span
								className="font-bold text-xl"
								style={{ color: textColor ?? "white" }}
							>
								{title.charAt(0).toLocaleUpperCase()}
							</span>
						</div>
						<CardTitle>{title}</CardTitle>
					</div>
					{onActivationUpdate && (
						<Switch value={!!activated} onChange={onActivationUpdate} />
					)}
				</div>
				{badge && <IntegrationConfigurationTag type={badge} />}
				<CardDescription className="max-w-full">{description}</CardDescription>
			</CardHeader>

			<CardContent>
				<IntegrationDialog
					title={title}
					description={description}
					seeMoreUrl={seeMoreUrl}
					logo={logo}
					onConfigure={onConfigure}
					open={open}
				>
					{children}
				</IntegrationDialog>
			</CardContent>
		</Card>
	);
}

export function IntegrationPreviewsContainer({ children }: PropsWithChildren) {
	return (
		<div className="pt-8 gap-2 grid grid-cols-2 grid-flow-row">{children}</div>
	);
}
